export default "__VITE_ASSET__Br88esTa__";